var map = {
	"./": "5oGM",
	"./CSS": "aBKk",
	"./CSS.tsx": "aBKk",
	"./Express": "evwZ",
	"./Express.tsx": "evwZ",
	"./Gatsby": "yc62",
	"./Gatsby.tsx": "yc62",
	"./GraphQl": "wz0h",
	"./GraphQl.tsx": "wz0h",
	"./HTML": "ZjEn",
	"./HTML.tsx": "ZjEn",
	"./Illustrator": "bjlH",
	"./Illustrator.tsx": "bjlH",
	"./JavaScript": "pWBV",
	"./JavaScript.tsx": "pWBV",
	"./MySQL": "oy3u",
	"./MySQL.tsx": "oy3u",
	"./Nextjs": "9kO3",
	"./Nextjs.tsx": "9kO3",
	"./Nodejs": "7rNW",
	"./Nodejs.tsx": "7rNW",
	"./ReactIcon": "hM2J",
	"./ReactIcon.tsx": "hM2J",
	"./Redux": "jdnH",
	"./Redux.tsx": "jdnH",
	"./Sass": "9Kx+",
	"./Sass.tsx": "9Kx+",
	"./Threejs": "Lmej",
	"./Threejs.tsx": "Lmej",
	"./TypeScript": "R9/J",
	"./TypeScript.tsx": "R9/J",
	"./Xd": "0umo",
	"./Xd.tsx": "0umo",
	"./index": "5oGM",
	"./index.ts": "5oGM"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "NDHY";